// Service Worker Registration for GT L.A.B Careers PWA
// Hardened update path: fetch the SW script bypassing the HTTP cache (updateViaCache:'none'),
// check for updates on every load, and sweep/unregister any FOREIGN service worker left by
// an older build under the same scope so a stale ghost can't keep serving dead assets.

export function register(config) {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    // 1) Unregister any foreign SW (different script) that an old build may have left.
    try {
      const existing = await navigator.serviceWorker.getRegistrations();
      let removedForeign = false;
      for (const reg of existing) {
        const scriptURL =
          (reg.active && reg.active.scriptURL) ||
          (reg.waiting && reg.waiting.scriptURL) ||
          (reg.installing && reg.installing.scriptURL) || '';
        if (scriptURL && !scriptURL.endsWith('/service-worker.js')) {
          await reg.unregister();
          removedForeign = true;
        }
      }
      // Reload once (guarded) after clearing a foreign ghost so ours takes over cleanly.
      if (removedForeign && !sessionStorage.getItem('sw_foreign_swept')) {
        sessionStorage.setItem('sw_foreign_swept', '1');
        window.location.reload();
        return;
      }
    } catch (e) { console.warn('SW foreign-sweep failed (non-critical):', e); }

    // 2) Register ours, telling the browser to NEVER use the HTTP cache for the SW script.
    try {
      const registration = await navigator.serviceWorker.register(swUrl, { updateViaCache: 'none' });

      // Check for a new SW on every load + hourly thereafter.
      registration.update();
      setInterval(() => registration.update(), 60 * 60 * 1000);

      registration.onupdatefound = () => {
        const installing = registration.installing;
        if (!installing) return;
        installing.onstatechange = () => {
          if (installing.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              if (config && config.onUpdate) config.onUpdate(registration);
            } else if (config && config.onSuccess) {
              config.onSuccess(registration);
            }
          }
        };
      };
    } catch (e) { console.warn('SW registration failed (non-critical):', e); }
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((e) => console.warn('SW unregister failed (non-critical):', e));
  }
}
